<template>
  <div id="app">
    <!-- 头部表单 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input
          size="small"
          v-model="queryParams.teamName"
          clearable
          placeholder="请输入小组名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          clearable
          v-model="queryParams.schoolName"
          placeholder="请输入学校名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          clearable
          v-model="queryParams.teacherName"
          placeholder="请输入教师名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onGetTeamUsersList" size="small">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-download" @click="handleImport" type="primary" size="small"
        >导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="multiple" @click="handleDelete" type="danger" size="small"
        >批量删除</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      border
      ref="multipleTable"
      :data="teamUsersList"
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      style="width: 100%; margin-bottom: 20px"
      @select="handleSelectionChange"
      @select-all="handleSelectionAll"
    >
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        prop="teamName"
        label="小组名称"
        width="240"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="schoolName"
        label="学校名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="teacherName"
        label="教师名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="mobile"
        label="手机号"
      ></el-table-column>
      <el-table-column align="center" prop="" label="操作">
        <template slot-scope="scope">
          <el-button style="color:#ff5151" type="text" @click="handleDelete(scope.row)"
          >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="totalCount"
    ></el-pagination>
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                   @click="importTemplate">下载模板
          </el-link>

        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 导入成功后展示 -->
    <el-dialog
      top="0"
      title="导入结果统计"
      :visible.sync="importResultDialog"
      width="30%"
      style="text-align: left; margin-top: 50px; float: right"
    >
      <el-row id="ID">
        <el-col :span="24" style="font-weight: bold; margin-bottom: 10px"
        >成功信息</el-col
        >
        <el-col :span="24">成功导入 {{ importResult.scount }} 条</el-col>
        <el-col :span="24" style="font-weight: bold; margin-top: 10px"
        >失败信息</el-col
        >
        <el-col :span="24">
          <el-table
            :data="importResult.errorMsgs"
            border
            stripe
            style="width: 100%; margin-top: 15px"
            highlight-current-row
          >
            <el-table-column
              prop="row"
              label="错误行数"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="msg"
              label="错误信息"
              align="center"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { ERR_OK } from "@/api/index";
import {deleteTeamUsersList, downloadTeamUsersImportTemplate, fuUrl, getTeamUsersList} from "../../api/home";
export default {
  data() {
    return {
      queryParams: {
        teamName: "",
        schoolName: "",
        teacherName: "",
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      teamUsersList: [],
      ids: [],
      // 非多个禁用
      multiple: true,
      upload: {
        open: false,
        title: "",
        isUploading: false,
        updateSupport: 0,
        version: undefined,
        headers: {token: localStorage.getItem('token')},
        // 上传的地址
        url: fuUrl + "/course/team/resources/usersImport?groupId=" + localStorage.getItem("groupId")
      },
      groupId: localStorage.getItem("groupId"),
      importResult: {},
      importResultDialog: false
    };
  },
  created() {
    this.onGetTeamUsersList();
  },
  methods: {
    // 页码变化
    currentChange(e) {
      this.queryParams.curPage = e;
      this.onGetTeamUsersList();
    },
    /** 导入按钮操作 */
    handleImport() {
      this.upload.title = "导入";
      this.upload.open = true;
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.importResult = response.data;
      this.importResultDialog = true;
      if(this.importResult.scount > 0) {
        this.onGetTeamUsersList();
      }
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    /** 下载模板操作 */
    async importTemplate() {
      await downloadTeamUsersImportTemplate();
    },
    // 资源单选
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    // 资源全选
    handleSelectionAll(val) {
      if (val.length === 0) {
        this.teamUsersList.forEach((item, index) => {
          let idx = this.ids.indexOf(item.id);
          if (idx !== -1) {
            this.ids.splice(idx, 1);
          }
        });
      } else {
        val.forEach((item) => {
          let idx = this.ids.indexOf(item.id);
          if (idx === -1) {
            this.ids.push(item.id);
          }
        });
      }
      this.multiple = this.ids.length > 0;
    },
    // 获取小组成员列表
    onGetTeamUsersList() {
      getTeamUsersList(this.queryParams).then((res) => {
        this.teamUsersList = res.data.data.dataList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let ids = row.id || this.ids;
      this.$confirm("是否确认删除？","提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTeamUsersList(ids).then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.onGetTeamUsersList();
        });
      }).catch(() => {
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/resources/team.vue